import React from "react";
import PropTypes from "prop-types";
import { Descriptions } from "../constants/descriptions";
import SubmissionNameHelp from "./SubmissionNameHelp";
import HelperText from "../../../components/atoms/HelperText";
import {
  Input,
  FormGroup,
  InputHelperText,
  Label,
} from "../../../components/atoms/Form";

const SubmissionName = (props) => {
  const { onChange, usersubmissionName } = props;

  const onChangeSubmissionName = (e) => {
    onChange(e.target.value, "submissionName");
  };

  return (
    <FormGroup className="tw-flex tw-w-6/12">
      <Label text="Submission Name" />
      <Input
        type="text"
        name="submissionName"
        id="submissionName"
        value={usersubmissionName}
        onChange={(event) => onChangeSubmissionName(event)}
      />
      <InputHelperText>
        {Descriptions.submissionName}
        <HelperText RenderContent={() => <SubmissionNameHelp />} />
      </InputHelperText>
    </FormGroup>
  );
};

SubmissionName.propTypes = {
  onChange: PropTypes.func.isRequired,
  usersubmissionName: PropTypes.string,
};

SubmissionName.defaultProps = {
  usersubmissionName: "",
};

export default SubmissionName;
